import { CSSObject, Theme, styled } from "@mui/material/styles";
import List from "@mui/material/List";
import MuiDrawer from "@mui/material/Drawer";
import React, { useContext, useEffect, useState } from "react";
import { Icon } from "../Icon";
import PinnedItems from "./components/PinnedItems";
import NavItems from "./components/NavItems";
import { SidebarTypes } from "./types";
import { SidebarMenuContext } from "contexts/SidebarMenuContext";
import { TabsMenuContext } from "contexts/TabsMenuContext";
import clsx from "clsx";
// import { APP_DETAILS } from "constants";

const drawerWidth = 260;

const openedMixin = (theme: Theme): CSSObject => ({
  width: drawerWidth,
  // transition: theme.transitions.create("width", {
  //   easing: theme.transitions.easing.sharp,
  //   duration: theme.transitions.duration.enteringScreen,
  // }),
  overflowX: "hidden",
});

const closedMixin = (theme: Theme): CSSObject => ({
  // transition: theme.transitions.create("width", {
  //   easing: theme.transitions.easing.sharp,
  //   duration: theme.transitions.duration.leavingScreen,
  // }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(7)} + 1px)`,
  },
});

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  // neutral-35 — light sidebar panel, matching the catalog UI shots.
  // The active item is the dark navy pill (`bg-primary-90` in NavLink).
  "& .MuiPaper-root": { backgroundColor: "#DADEE4", border: "none" },
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

const Sidebar = (props: SidebarTypes) => {
  const sidebarMenuContext = useContext(SidebarMenuContext);
  const { className } = props;
  const { flatMenu, menu } = useContext(TabsMenuContext);
  const [searchedValue, setSearchedValue] = useState("");
  const onSearchInputChange = (e: any) => {
    setSearchedValue(e.target.value);
  };

  useEffect(() => {
    console.log("!!flatMenu", flatMenu);
    console.log("!!menu", menu);
  }, [flatMenu, menu]);

  return (
    <Drawer
      style={{ direction: "ltr" }}
      classes={{
        paper: "pb-[34px]",
      }}
      open={sidebarMenuContext.expand}
      variant="permanent"
      className={className}
    >
      <div>
        {sidebarMenuContext.expand ? (
          <>
            {/*<Link*/}
            {/*  href="/"*/}
            {/*  className="items-center mx-auto pb-8 pt-3 flex justify-center"*/}
            {/*>*/}
            {/*  <Image*/}
            {/*    src={APP_DETAILS.image}*/}
            {/*    width={210}*/}
            {/*    height={50}*/}
            {/*    alt="مفید"*/}
            {/*  />*/}
            {/*</Link>*/}
            <a
              className={"flex w-full justify-center items-center mt-2 mb-4"}
              href={"/dashboard"}
            >
              <img width={200} src={"/samaLogo.png"} />
            </a>
            <div
              style={{ direction: "rtl" }}
              className="flex flex-row items-center mx-5 px-2 justify-between h-[34px] outline-none bg-neutral-25 rounded-[17px] text-gray-60"
            >
              <input
                autoFocus
                type="text"
                name="sideBarSearch"
                value={searchedValue}
                className="bg-neutral-25 px-3 rounded-[17px] text-gray-60 outline-none"
                onChange={onSearchInputChange}
                placeholder={"جستجو ..."}
                autoComplete={"off"}
              />
              <Icon
                onClick={() => setSearchedValue("")}
                icon="MdClear"
                fontSize="1.25rem"
                className={clsx(
                  "text-neutral-60",
                  searchedValue.length > 0
                    ? "opacity-100 cursor-pointer"
                    : "opacity-0"
                )}
              />
            </div>
          </>
        ) : (
          <>
            {/*<Link*/}
            {/*  href="/"*/}
            {/*  className="items-center mx-auto pb-8 pt-3 flex justify-center"*/}
            {/*>*/}
            {/*  <Image*/}
            {/*    src={APP_DETAILS.brandmark}*/}
            {/*    height={50}*/}
            {/*    width={50}*/}
            {/*    alt="مفید"*/}
            {/*  />*/}
            {/*</Link>*/}
            <a
              className={"flex w-full justify-center items-center mt-6 mb-8"}
              href={"/dashboard"}
            >
              <img width={42} src={"/sama.png"} />
            </a>
            <div
              className="w-full flex items-center justify-center h-[34px] cursor-pointer hover:bg-neutral-40"
              onClick={() => {
                setSearchedValue("");
                sidebarMenuContext.openExpand();
              }}
            >
              <Icon
                icon="MdSearch"
                fontSize="1.25rem"
                className={clsx("text-neutral-60 margin-auto w-full ")}
              />
            </div>
          </>
        )}
      </div>
      {sidebarMenuContext.expand && <PinnedItems className={"mt-6"} />}
      <div className="overflow-y-auto mt-4">
        <List
          style={{ direction: "rtl" }}
          className="nav-items"
          sx={{ pt: 0, "& > :first-of-type": { mt: "0" } }}
        >
          <NavItems
            searchedValue={searchedValue}
            flatMenuItems={flatMenu}
            verticalNavItems={menu}
            {...props}
          />
        </List>
      </div>
      <div
        className={clsx(
          "w-full flex items-center bg-neutral-40 hover:bg-neutral-45 hover:cursor-pointer h-[34px] absolute bottom-0",
          sidebarMenuContext.expand ? "justify-start" : "justify-center"
        )}
        onClick={() => {
          setSearchedValue("");
          sidebarMenuContext.expand
            ? sidebarMenuContext.closeExpand()
            : sidebarMenuContext.openExpand();
        }}
      >
        <Icon
          fontSize="24"
          className={clsx(
            "cursor-pointer text-gray-70",
            sidebarMenuContext.expand && "ml-4"
          )}
          icon={
            sidebarMenuContext.expand
              ? "MdKeyboardArrowRight"
              : "MdKeyboardArrowLeft"
          }
        />
      </div>
    </Drawer>
  );
};

export default Sidebar;
